import {
  EngineeringSOFData,
  EngineeringSOFProjectData,
  RadData,
} from '@models/interfaces';
import { processScopingEquipmentInfo } from '@modules/client/pages/engineering/helpers';

export const processUpdateSOFBody = (data: EngineeringSOFData) => {
  const {
    projectInfo: { RADA, RADB, RADG, RADD, ...restProjectInfo },
    ...dataWithouRADs
  } = processScopingEquipmentInfo(data);

  const RADs = {
    RADA,
    RADB,
    RADG,
    RADD,
  } as EngineeringSOFProjectData;

  const RAD = Object.keys(RADs).reduce((acc: RadData[], RADKey: string) => {
    const RADScopingValue = RADs[RADKey as keyof EngineeringSOFProjectData];

    return [
      ...acc,
      ...(RADScopingValue
        ? [
            {
              RADField: RADKey.substring(3),
              scoping: RADScopingValue,
            } as RadData,
          ]
        : []),
    ];
  }, []);

  return { ...dataWithouRADs, projectInfo: { ...restProjectInfo, RAD } };
};
